import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import {
  parseAsInteger,
  parseAsIsoDateTime,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';

type SortOrder = (typeof dataGridSortDirection)[number];

export default function useExamResultFileListSearchParams() {
  const [
    { page, pageSize, sortOrder, sortBy, search, createdDateFrom, createdDateTo },
    setExamResultFileListSearchParams,
  ] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(10),
    sortOrder: parseAsStringLiteral(dataGridSortDirection).withDefault('desc'),
    sortBy: parseAsString.withDefault('createdAt'),
    search: parseAsString.withDefault(''),
    createdDateFrom: parseAsIsoDateTime,
    createdDateTo: parseAsIsoDateTime,
  });

  const changePageNumber = (page: number) => {
    setExamResultFileListSearchParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setExamResultFileListSearchParams({ pageSize, page: 0 });
  };

  const changeSorting = ({
    sortOrder,
    sortBy,
  }: {
    sortOrder: SortOrder | null;
    sortBy: string | null;
  }) => {
    setExamResultFileListSearchParams({ sortOrder, page: 0, sortBy });
  };

  const changeSearch = (value: string) => {
    setExamResultFileListSearchParams({ search: value, page: 0 });
  };

  const changeCreatedDateRange = (from: Date | null, to: Date | null) => {
    setExamResultFileListSearchParams({ createdDateFrom: from, createdDateTo: to, page: 0 });
  };

  return [
    {
      page,
      pageSize,
      sortOrder,
      sortBy,
      search,
      createdDateFrom,
      createdDateTo,
    },
    {
      changePageNumber,
      changePageSize,
      changeSorting,
      changeSearch,
      changeCreatedDateRange,
    },
  ] as const;
}
